"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var zh = {
    home: "首頁",
    productCenter: "產品中心",
    about: "關於我們",
    aboutContent: "台灣研發團隊自行開發「物聯網與智能安防」相關產品以及雲端之技術開發與產品設計，且能依照客戶需求打造專屬客製化產品，並擁有良好的製造及銷售通路。",
    contact: "聯絡我們",
    lightPorduct: "燈泡產品",
    plugPorduct: "插座產品",
    extensionCordPorduct: "延長線產品",
    securityPorduct: "安防產品",
    address: "235新北市中和區中正路872號16F-6",
    validationValue: "資料尚未填寫",
    validationMail: "信箱格式錯誤",
    userName: "姓名 *",
    subject: "主旨 *",
    body: "內容/需求 *",
    mailResult: "感謝您的來信，將會盡快處理您的問題。",
    send: "送出",
};
exports.default = zh;
